export enum COProductCardPropsEnums {
  DRAFT = 'draft',
  APPROVED = 'approved',
  DECLINED = 'declined',
  TEMP_ADDRESS = 'Brampton Manuf....nd Sales Centre',
  LABEL = 'Label',
  APPROVAL_REPORT = 'Approval Report',
  DUPLICATE = 'Duplicate',
  DELETE = 'Delete',
  QUANTITY = 'Quantity',
  QUANTITY_VALUE = '10,000',
  FARM_REVENUE = '% of farm revenue',
  MASS_ALLOCATION = 'Mass allocation',
  ALLOCATION_VALUE = '100',
  TOTAL_WEIGHT = 'Total weight (kg)',
  LIVESTOCK_TYPE = 'Livestock Type',
}
export enum MenuItemKey {
  REPORT = 'report',
  LABEL = 'label',
  COPY = 'copy',
  DELETE = 'delete',
}
